'use client';
import { usePushProps, usePush } from '@/common/usePush';
import { PFButton } from './PFButton';
import { CiBellOn, CiBellOff } from 'react-icons/ci';
import { IoCheckbox, IoSquareOutline } from 'react-icons/io5';

import { useEffect, useState } from 'react';
import { PFText } from './PFText';
import Spinner from './Spinner';

type Props = {
  tag: usePushProps;
  variant?: 'baseRounded' | 'binIcon' | 'base';
  toggleGeneral?: boolean;
};

export function PushAbo(props: Props) {
  const { toggleGeneral, variant } = props;
  const { askPermission, subscribeButtonOnClick, isSubscribed } = usePush(
    props.tag,
    toggleGeneral,
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => setLoading(false), []);

  if (variant === 'binIcon') {
    return (
      <button
        onClick={(event) => {
          askPermission()
            .then(() => {
              subscribeButtonOnClick(event);
            })
            .catch((err) => {
              console.error(err);
            });
        }}
        disabled={loading}
      >
        {loading ? (
          <Spinner />
        ) : (
          <>
            <PFText size="base">
              {isSubscribed ? (
                <IoCheckbox className="w-base h-base text-primaryColor" />
              ) : (
                <IoSquareOutline className="w-base h-base text-primaryColor" />
              )}
            </PFText>
          </>
        )}
      </button>
    );
  }

  return (
    <PFButton
      onClick={(event) => {
        askPermission()
          .then(() => {
            subscribeButtonOnClick(event);
          })
          .catch((err) => {
            console.error(err);
          });
      }}
      variant={'baseRounded'}
      className="!p-2 !w-[280px] min-h-10"
      disabled={loading}
    >
      {loading ? (
        <Spinner />
      ) : (
        <>
          {isSubscribed ? (
            <CiBellOff className="h-6 w-6" />
          ) : (
            <CiBellOn className="h-6 w-6" />
          )}
          <PFText size="small" className="font-normal">
            {isSubscribed ? 'Push Deaktivieren' : 'News per Push abonnieren'}
          </PFText>
        </>
      )}
    </PFButton>
  );
}
